import { render } from "./errorRegistration.vue?vue&type=template&id=fb620822"
import script from "./errorRegistration.vue?vue&type=script&lang=ts"
export * from "./errorRegistration.vue?vue&type=script&lang=ts"
script.render = render

export default script